var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.27 8.13-2.12-3.97a2.44 2.44 0 0 0-4.3 0l-2.12 3.97c-.35.66-1 1.12-1.73 1.25l-4.48.76a2.4 2.4 0 0 0-1.33 4.05l3.17 3.22c.52.53.77 1.28.66 2.02l-.65 4.45a2.42 2.42 0 0 0 3.48 2.5l4.08-1.99a2.45 2.45 0 0 1 2.14 0l4.08 1.98a2.42 2.42 0 0 0 3.48-2.5l-.65-4.44c-.1-.74.14-1.49.66-2.02l3.17-3.22a2.4 2.4 0 0 0-1.33-4.05L21 9.38a2.43 2.43 0 0 1-1.73-1.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.6f05a1de88f8d20acb4d3a0244935eb3.svg";
export { ForwardRef as ReactComponent };